import React, { useState } from 'react';
import MultiSelectModal from '../../Modal/MultiSelectModal';
import '@fortawesome/fontawesome-free/css/all.min.css';

export type EntityItem = { id: number | string; name?: string | null };

export type EntityListProps<T extends EntityItem> = {
  items: T[];
  getDisplayName: (item: T) => string;
  onUpdate: (item: T) => void;
  onDelete: (item: T) => void;
};

function EntityList<T extends EntityItem>({
  items,
  getDisplayName,
  onUpdate,
  onDelete,
}: EntityListProps<T>) {
  const [menuOpenId, setMenuOpenId] = useState<number | string | null>(null);
  const [deleteTarget, setDeleteTarget] = useState<T | null>(null);

  const handleDeleteClick = (item: T) => {
    setMenuOpenId(null);
    setDeleteTarget(item);
  };

  const handleConfirmDelete = () => {
    if (deleteTarget) {
      onDelete(deleteTarget);
      setDeleteTarget(null);
    }
  };

  const handleUpdateClick = (item: T) => {
    setMenuOpenId(null);
    onUpdate(item);
  };

  return (
    <>
      <ul className="list-group list-group-flush">
        {items.map((item) => (
          <li
            key={String(item.id)}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            <span>{getDisplayName(item)}</span>
            <div className="dropdown">
              <button
                type="button"
                className="btn btn-link btn-sm text-secondary p-0"
                id={`menu-${item.id}`}
                data-bs-toggle="dropdown"
                aria-expanded={menuOpenId === item.id}
                onClick={() => setMenuOpenId(menuOpenId === item.id ? null : item.id)}
              >
                <i className="fas fa-ellipsis-v" />
              </button>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby={`menu-${item.id}`}>
                <li>
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={() => handleUpdateClick(item)}
                  >
                    Güncelle
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    className="dropdown-item text-danger"
                    onClick={() => handleDeleteClick(item)}
                  >
                    Sil
                  </button>
                </li>
              </ul>
            </div>
          </li>
        ))}
      </ul>
      {deleteTarget && (
        <MultiSelectModal
          title="Silmek istediğinize emin misiniz?"
          message={getDisplayName(deleteTarget)}
          onAccept={handleConfirmDelete}
          onReject={() => setDeleteTarget(null)}
        />
      )}
    </>
  );
}

export default EntityList;
